/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import BannerSkeleton from './BannerSkeleton';
import Banner from './banner/Banner';
import HomeSlider from './HomeSlider';

export default class HomeFacadeBlock extends Component {
	oninit(vnode) {
		super.oninit(vnode);
		this.loading = true;
		this.banners = [];
		this.refresh();
	}

	view() {
		const { banners } = this;

		// Don't render anything if there are no banners (& loading done)
		if (!banners.length) {
			if (this.loading) {
				return <BannerSkeleton />;
			}

			if (!app.noHomeFacadeBlock) {
				app.noHomeFacadeBlock = {};
			}
			if (app.noHomeFacadeBlock[this.attrs.position] !== true) {
				app.noHomeFacadeBlock[this.attrs.position] = true;
				setTimeout(() => m.redraw(), 1);
			}

			return <div></div>;
		} else {
			if (!app.noHomeFacadeBlock) {
				app.noHomeFacadeBlock = {};
			}
			if (app.noHomeFacadeBlock[this.attrs.position] !== false) {
				app.noHomeFacadeBlock[this.attrs.position] = false;
				setTimeout(() => m.redraw(), 1);
			}
		}

		// We only display one item here
		const banner = banners[0];

		return (
			<div className="HomeFacadeBlock">
				<Banner banner={banner} />
			</div>
		);
	}

	async refresh(clear = true) {
		await HomeSlider.prototype.refresh.call(this, clear, this.attrs.position);
	}

	clear() {
		this.loading = true;
		this.banners = [];
		m.redraw();
	}

	parseResults(results) {
		HomeSlider.prototype.parseResults.call(this, results);

		this.banners = this.items;
	}
}
